import { render } from "./MyNotifications.vue?vue&type=template&id=54912118"
import script from "./MyNotifications.vue?vue&type=script&lang=js"
export * from "./MyNotifications.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MyNotifications.vue?vue&type=style&index=0&id=54912118&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__